import {
  MGR_ORDERS_REQUEST,
  MGR_ORDERS_STATUS_LIST_REQUEST,
  MGR_SET_PRICE_ITEM,
  MGR_PRICEHEADERS_REQUEST,
  MGR_REQUEST_PRICE_STATES,
  MGR_PRICE_LIST_REQUEST

} from '../actions/mgr'
import { UI_REQUEST, UI_SUCCESS, UI_ERROR } from '@/store/actions/ui'
import axios from 'axios'

const state = {
  mgrOrdersList: [],
  mgrOrdersStatusList: [],
  mgrPriceheadersList: [],
  mgrPriceStatusList: [],
  mgrPriceList: [],
  mgrPriceItem: {},
  status: ''
}

const getters = {
  getMgrOrdersList: state => state.mgrOrdersList,
  getMgrOrdersStatusList: state => state.mgrOrdersStatusList,
  getMgrPriceheadersList: state => state.mgrPriceheadersList,
  getPriceStatusList: state => state.mgrPriceStatusList,
  getMgrPriceList: state => state.mgrPriceList
}

const actions = {
  [MGR_ORDERS_STATUS_LIST_REQUEST]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'MGR_ORDERS_STATUS_LIST_REQUEST', topic: 'Запрос статусов', error: null })
      axios({ url: '/api/mgr/orders/getOrdersStatusList.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            dispatch(UI_SUCCESS, { action: 'MGR_ORDERS_STATUS_LIST_REQUEST' })
            commit(MGR_ORDERS_STATUS_LIST_REQUEST, resp.data.data)
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'MGR_ORDERS_STATUS_LIST_REQUEST', result: resp.data.error_text })
            reject(resp.data.error)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'MGR_ORDERS_STATUS_LIST_REQUEST', result: err })
          reject(new Error(err))
        })
    }),
  [MGR_ORDERS_REQUEST]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'MGR_ORDERS_REQUEST', topic: 'Запрос статусов', error: null })
      axios({ url: '/api/mgr/orders/getOrdersList.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            dispatch(UI_SUCCESS, { action: 'MGR_ORDERS_REQUEST' })
            commit(MGR_ORDERS_REQUEST, resp.data.data)
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'MGR_ORDERS_REQUEST', result: resp.data.error_text })
            reject(resp.data.error)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'MGR_ORDERS_REQUEST', result: err })
          reject(new Error(err))
        })
    }),
  [MGR_PRICEHEADERS_REQUEST]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'MGR_PRICEHEADERS_REQUEST', topic: 'Запрос статусов', error: null })
      axios({ url: '/api/mgr/price/getPriceheadersList.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            dispatch(UI_SUCCESS, { action: 'MGR_PRICEHEADERS_REQUEST' })
            commit(MGR_PRICEHEADERS_REQUEST, resp.data.data)
            resolve(resp.data)
          } else {
            dispatch(UI_ERROR, { action: 'MGR_PRICEHEADERS_REQUEST', result: resp.data.error_text })
            reject(resp.data.error)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'MGR_PRICEHEADERS_REQUEST', result: err })
          reject(new Error(err))
        })
    }),
  [MGR_PRICE_LIST_REQUEST]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'MGR_PRICE_LIST_REQUEST', topic: 'Запрос статусов', error: null })
      axios({ url: '/api/mgr/price/getPriceList.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            dispatch(UI_SUCCESS, { action: 'MGR_PRICE_LIST_REQUEST' })
            commit(MGR_PRICE_LIST_REQUEST, resp.data.data)
            resolve(resp.data)
          } else {
            dispatch(UI_ERROR, { action: 'MGR_PRICE_LIST_REQUEST', result: resp.data.error_text })
            reject(resp.data.error)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'MGR_PRICE_LIST_REQUEST', result: err })
          reject(new Error(err))
        })
    }),
  [MGR_REQUEST_PRICE_STATES]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'MGR_PRICE_LIST_REQUEST', topic: 'Запрос статусов', error: null })
      axios({ url: '/api/mgr/price/getPriceStatesList.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            dispatch(UI_SUCCESS, { action: 'MGR_PRICE_LIST_REQUEST' })
            commit(MGR_REQUEST_PRICE_STATES, resp.data.data)
            resolve(resp.data)
          } else {
            dispatch(UI_ERROR, { action: 'MGR_PRICE_LIST_REQUEST', result: resp.data.error_text })
            reject(resp.data.error)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'MGR_PRICE_LIST_REQUEST', result: err })
          reject(new Error(err))
        })
    }),
  [MGR_SET_PRICE_ITEM]: ({ commit }, priceItem) => {
    commit(MGR_SET_PRICE_ITEM, priceItem)
    // resolve(orderItem)
  }
}

const mutations = {
  [MGR_ORDERS_REQUEST]: (state, resp) => {
    state.status = 'success'
    console.log('MGR_ORDERS_REQUEST mutation initiated, ', resp)
    state.mgrOrdersList = resp
  },
  [MGR_PRICEHEADERS_REQUEST]: (state, resp) => {
    state.status = 'success'
    console.log('MGR_PRICEHEADERS_REQUEST mutation initiated, ', resp)
    state.mgrPriceheadersList = resp
  },
  [MGR_PRICE_LIST_REQUEST]: (state, resp) => {
    state.status = 'success'
    console.log('MGR_PRICE_LIST_REQUEST mutation initiated, ', resp)
    state.mgrPriceList = resp
  },
  [MGR_ORDERS_STATUS_LIST_REQUEST]: (state, resp) => {
    state.status = 'success'
    console.log('MGR_ORDERS_STATUS_LIST_REQUEST mutation initiated, ', resp)
    state.mgrOrdersStatusList = resp
  },
  [MGR_REQUEST_PRICE_STATES]: (state, resp) => {
    state.status = 'success'
    console.log('MGR_REQUEST_PRICE_STATES mutation initiated, ', resp)
    state.mgrPriceStatusList = resp
  },
  [MGR_SET_PRICE_ITEM]: (state, resp) => {
    state.status = 'success'
    console.log('MGR_SET_PRICE_ITEM mutation initiated, ', resp)
    state.mgrPriceItem = resp
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
